<template>
  <v-bottom-sheet
      v-model="sheet"
      scrollable
      persistent
      no-click-animation
      :overlay-opacity="0.7"
      content-class="bottom-sheet"
  >
    <v-card>
      <SheetHeader :title="datas[flag].title" @sheetClose="$emit('sheetClose')"/>
      <v-card-text class="sheet-body">
        {{ datas[flag].des }}
      </v-card-text>
    </v-card>
  </v-bottom-sheet>
</template>

<script>
import SheetHeader from "./SheetHeader";

export default {
  props: {
    sheet: Boolean,
    flag: Number,
  },
  data: () => ({
    datas: [
      {title: '마음날씨', des: '마음 날씨는 하루하루 기록한 안녕감 및 마음 상태를 그래프로 보여줍니다.'},
      {title: '몸 날씨', des: '몸 날씨는 하루하루 기록한 건강 및 컨디션 상태를 그래프로 보여줍니다.'},
      {title: '기분 날씨', des: '기분 날씨는 하루하루 기록한 감정 및 기분 상태를 그래프로 보여줍니다.'}
    ]
  }),
  components: {
    SheetHeader
  },
  computed: {},
  methods: {}

}
</script>

<style lang="scss" scoped>
::v-deep .v-dialog {
  .sheet-body {
    word-break: keep-all;
    font-size: var(--v-fs-lg);
    color: var(--v-text-body-base);
  }
}
</style>
